"use strict";
// Used for external things like our SDK websocket and rest apis
Object.defineProperty(exports, "__esModule", { value: true });
exports.LumiaEventTypes = void 0;
var LumiaEventTypes;
(function (LumiaEventTypes) {
    LumiaEventTypes["STATES"] = "states";
    LumiaEventTypes["CHAT"] = "chat";
    LumiaEventTypes["COMMAND"] = "command";
    LumiaEventTypes["TWITCH_POINTS"] = "twitch_point";
    LumiaEventTypes["TWITCH_EXTENSIONS"] = "twitch_extension";
    LumiaEventTypes["TROVO_SPELL"] = "trovo_spell";
    LumiaEventTypes["PULSE"] = "pulse";
    LumiaEventTypes["ALERTS"] = "alert";
    LumiaEventTypes["GAMESGLOW_ALERT"] = "gamesglow_alert";
    LumiaEventTypes["GAMESGLOW_COMMAND"] = "gamesglow_command";
    LumiaEventTypes["GAMESGLOW_VIRTUALLIGHT"] = "gamesglow_virtuallight";
})(LumiaEventTypes = exports.LumiaEventTypes || (exports.LumiaEventTypes = {}));
//# sourceMappingURL=event.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@lumiastream/lumia-types/dist/event.types.js
// module id = 317
// module chunks = 0